import { render, staticRenderFns } from "./sync-history.vue?vue&type=template&id=f03020a4&scoped=true"
import script from "./sync-history.vue?vue&type=script&lang=ts"
export * from "./sync-history.vue?vue&type=script&lang=ts"
import style0 from "./sync-history.vue?vue&type=style&index=0&id=f03020a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03020a4",
  null
  
)

export default component.exports